import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { ButtonsWrapper } from '../../AllLanguages/AllLanguages.style';
import {
    AddTableRowPropsType,
    AddTableRowState,
} from 'src/components/TranslationsContent/SelectedLanguage/AddTableRow/AddTableRow.state';
import { Button } from 'src/domains/layouts/shared/buttons/Button';

export const AddTableRow = observer('AddTableRow', (props: AddTableRowPropsType) => {
    const [state] = useState(() => new AddTableRowState(props));
    const inputRef = useRef<null | HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current !== null) {
            inputRef.current.focus();
        }
    }, []);

    return (
        <tr>
            <td>
                <input type='text' ref={inputRef} autoFocus={true} value={state.key} onChange={state.onKeyChange} />
            </td>

            <td>
                <input type='text' value={state.value} onChange={state.onValueChange} />
            </td>

            {state.saving ? (
                <td>
                    <div className='spinner spinner--inline spinner-small' />
                </td>
            ) : (
                <td>
                    <ButtonsWrapper>
                        <Button onClick={state.props.onCancel} size='small' version='secondary'>
                            Cancel
                        </Button>
                        <Button onClick={state.onSaveClick} size='small'>
                            Save
                        </Button>
                    </ButtonsWrapper>
                </td>
            )}
        </tr>
    );
});
